import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { menuCategories } from '@/mocks/menuItems';

export default function MenuPage() {
  return (
    <>
      <Navbar />
      <main>
        <section className="pt-28 md:pt-36 pb-10 md:pb-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 text-center">
            <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
              Dine With Us
            </p>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 mb-4">
              Our Menu
            </h1>
            <p className="text-foreground-600 max-w-2xl mx-auto text-base md:text-lg">
              From traditional Karak chai to specialty blends and freshly made
              snacks, every item is prepared with care using the finest
              ingredients.
            </p>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-5xl mx-auto px-4 md:px-8 lg:px-12">
            {menuCategories.map((category, catIndex) => (
              <div
                key={category.id}
                className={`${catIndex > 0 ? 'mt-14 md:mt-20' : ''}`}
              >
                <div className="flex items-center gap-4 mb-8">
                  <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
                    {category.name}
                  </h2>
                  <div className="flex-1 h-px bg-background-300/60" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
                  {category.items.map((item) => (
                    <div
                      key={item.id}
                      className="group flex gap-4 p-4 md:p-5 rounded-lg border border-background-200/60 hover:border-primary-300/40 bg-background-50 hover:shadow-sm transition-all duration-300"
                    >
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-3 mb-2">
                          <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                            {item.name}
                          </h3>
                          <span className="font-label text-primary-600 font-semibold text-sm whitespace-nowrap">
                            {item.price}
                          </span>
                        </div>
                        <p className="text-foreground-600 text-sm leading-relaxed">
                          {item.description}
                        </p>
                        {item.badge && (
                          <span className="inline-block mt-2 px-2.5 py-0.5 bg-accent-100 text-accent-800 text-xs font-medium rounded-full">
                            {item.badge}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}